class scrollSlide extends HTMLElement {
  connectedCallback() {
    this.events = new AbortController()
    const options = { signal: this.events.signal }
    const wrapper = this.closest('.product-storytelling')
    const arrowBefore = wrapper?.querySelector('.arrow-before-wrapper')
    const arrowAfter = wrapper?.querySelector('.arrow-next-wrapper')
    let isDown = false
    let startX = 0
    let scrollLeft = 0

    const checkArrows = () => {
      const focused = document.activeElement
      if (arrowBefore) arrowBefore.disabled = this.scrollLeft <= 1
      if (arrowAfter) arrowAfter.disabled = this.clientWidth + this.scrollLeft >= this.scrollWidth - 2
      if ((focused === arrowBefore && arrowBefore.disabled) || (focused === arrowAfter && arrowAfter.disabled)) {
        this.focus({ preventScroll: true })
      }
    }

    const moveCarousel = (direction) => {
      this.scrollBy({
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        left: this.clientWidth * direction,
      })
    }

    arrowBefore?.addEventListener('click', () => moveCarousel(-1), options)
    arrowAfter?.addEventListener('click', () => moveCarousel(1), options)
    this.addEventListener('scroll', checkArrows, options)
    this.addEventListener('load', checkArrows, { ...options, capture: true })

    const stopDragging = () => {
      isDown = false
      this.classList.remove('active')
    }

    this.addEventListener('mousedown', (event) => {
      if (event.button !== 0 || event.target.closest('a, button, input, select, textarea')) return
      isDown = true
      this.classList.add('active')
      startX = event.pageX
      scrollLeft = this.scrollLeft
    }, options)

    this.addEventListener('mousemove', (event) => {
      if (!isDown) return
      event.preventDefault()
      this.scrollLeft = scrollLeft - (event.pageX - startX) * 3
    }, options)

    this.addEventListener('mouseleave', stopDragging, options)
    window.addEventListener('mouseup', stopDragging, options)
    this.resizeObserver = new ResizeObserver(checkArrows)
    this.resizeObserver.observe(this)
    checkArrows()
  }

  disconnectedCallback() {
    this.events?.abort()
    this.resizeObserver?.disconnect()
  }
}

if (!customElements.get('scroll-slide')) customElements.define('scroll-slide', scrollSlide)
